import React from 'react';
import styled from 'styled-components';
import * as Modals from 'styles/Modals';
import { media } from 'styles/Mixins';

const Text = styled.p`
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
  margin: 0 auto;
  width: ${({ width = 'auto' }) => width};
  padding-bottom: ${({ paddingBotton = 'auto' }) => paddingBotton};
`;

const Circle = styled.div`
  display: inline-block;
  height: 165px;
  width: 165px;
  background: #ffffff;
  border-radius: 50%;
  margin-top: 60px;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
`;

const ModalContent = styled.div`
  min-height: 324px;
  width: calc(100% - 30px);
  margin: 0 auto;
  ${media.md`
    width: 494px;
  `}
  border-radius: 2px;
  background: #278c7e;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Icon = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 86px;
  line-height: 113px;
`;

type PropsType = {
  message: string,
  show: boolean,
  timerClose: number,
  textWidth?: string,
  textPaddingBottom?: string,
  autoClose: boolean,
  handleCloseModal: () => void,
  icon?: any
};

const ModalAutoClose = ({
  icon,
  message,
  autoClose = true,
  show = false,
  timerClose = 5000,
  textWidth,
  textPaddingBottom,
  handleCloseModal = () => {}
}: PropsType) => {
  let timer = null;
  const closeModal = () => {
    timer = setTimeout(() => {
      handleCloseModal();
      clearTimeout(timer);
    }, timerClose);
  };

  const ModalIcon = () => {
    if (icon) return <Icon>{icon}</Icon>;
    else return <Icon>👍</Icon>;
  };

  if (show && autoClose) closeModal();

  return (
    <Modals.ScreenOverlay show={show}>
      <ModalContent>
        <Circle>
          <ModalIcon />
        </Circle>
        <Text paddingBotton={textPaddingBottom} width={textWidth}>
          {message}
        </Text>
      </ModalContent>
    </Modals.ScreenOverlay>
  );
};

export default ModalAutoClose;
